module.exports = __webpack_public_path__ + "images/49cc4262137fd1d5c1c4b5ed021ef1ff.jpg";